var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaneLanding = function SvgPlaneLanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.43 10.05c.05.127.15.228.275.278l3.91 1.55c.09.032.19.01.256-.058a.26.26 0 0 0 .057-.26l-2.017-4.994a.96.96 0 0 0-.502-.52l-2.11-.962c-.667-.3-1.404.244-1.327.98q.015.152.076.29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.799 16.14a2.37 2.37 0 0 0-1.26-1.299L7.37 9.645a.5.5 0 0 1-.275-.288l-.757-2.252a.96.96 0 0 0-.53-.587L3.372 5.45a.93.93 0 0 0-.947.087.97.97 0 0 0-.426.798v5.235c0 .394.236.749.596.894L7.88 14.61a.27.27 0 0 1 .151.222.24.24 0 0 1-.142.22L3.345 17.2a.964.964 0 0 0 .066 1.77l2.585.962a.9.9 0 0 0 .331.058.8.8 0 0 0 .265 0l7.575-2.27a.5.5 0 0 1 .293 0l4.252 1.548a2.28 2.28 0 0 0 1.827 0c1.209-.51 1.781-1.918 1.279-3.146z"
  })));
};
export default SvgPlaneLanding;